<template lang="pug">
  .container-settle.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/settle") 结算账户管理
          el-breadcrumb-item(:to="fromUrl") 富力钱包
          el-breadcrumb-item 提现
    c-box
      el-form(:model="source",label-position="right",label-width="100px")
        el-row
          el-col(:span="24")
            el-form-item(label="提现银行卡") {{def_wallet_card.deposit_bank}} （{{def_wallet_card.bank_account | substringForLast4}}）
        el-row
          el-col(:span="24")
            el-form-item(label="提现金额",style="width:400px;")
              el-input(v-model="amount", :placeholder="'请输入大于'+manual_withdraw_company_min+'元的金额'")
              div 可提现余额为 {{ (walletInfo.wallet_balance||0-walletInfo.freeze_amount||0) || 0 | toYuan }} 元，
                b.txt-tip-default(@click="getAllMoney") 全部提现
              div 预计 {{nextDay}} 前到账
          el-col(:span="24")
              el-button(type="primary", @click="withdraw()",style="margin-left:100px;") 提现
        el-row
          el-col(:span="24")
            el-form-item(label="提现规则")
              div 1、充值、提现均不收入任何服务费；
              div 2、每天最多提现一次，可以在交易记录中查到提现记录；
              div 3、单笔提现最低{{manual_withdraw_company_min}}元起提，提现金额不设上限，但是不能大于可提现余额。
    el-dialog(title="确认提现", :visible.sync="confirmDia",width="30%")
      el-form(label-position="right", label-width="125px", :validate-on-rule-change="false")
        el-form-item(label="提现金额", required)
          span {{realAmout | toYuan}} 元
        el-form-item(label="手机号验证", required)
          span(style="margin-right:30px") {{security_tel | desensitization}} 
          el-button(type="primary",@click="sendVerifyCode",v-if="!verify_locked",:disabled="isLoading") 获取验证码
          span(v-else) {{countdown}}S
        el-form-item(label="验证码", required)
          el-input(v-model="verify_code")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="smsConfirm()") 确定
        el-button(@click="confirmDia=false") 取消
</template>

<script>
export default {
  data() {
    return {
      source: {
        mobile: this.$store.state.mchDetail.resp_per_telephone_no,
        settle_account: this.$route.params.settle_account
      },
      amount: '',
      realAmout: 0,
      filters: {},
      verify_code: '',
      fromUrl: `/wallet/detail/${this.$route.params.settle_account}/${
        this.$route.params.settle_id
      }`,
      list: [],
      isSend: false,
      verify_locked: false,
      countdown: -1,
      listLoading: false,
      hasFilter: false,
      walletInfo: {},
      security_tel: '',
      confirmDia: false,
      ticket: '',
      nextDay: (() => {
        return new Date(
          new Date().getTime() + 24 * 60 * 60 * 1000
        ).toLocaleString()
      })(),
      manual_withdraw_company_min: 100,
      def_wallet_card: {},
      isLoading: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    mchDetail() {
      return this.$store.getters.mchDetail
    }
  },
  methods: {
    // 全部提现
    getAllMoney() {
      this.amount = (
        (this.walletInfo.wallet_balance ||
          0 - this.walletInfo.freeze_amount ||
          0) / 100
      ).toFixed(2)
    },
    getWalletInfo() {
      // 当前的钱包状态
      this.$store
        .dispatch('GET_WALLET_INFO', {
          settle_id: this.$route.params.settle_id
        })
        .then(res => {
          console.log(res)
          this.walletInfo = res.wallet
          //   this.tunnelInfo = res.wallet_tunnel;
          this.def_wallet_card = res.def_wallet_card
          this.security_tel = res.wallet_tunnel.security_tel
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: 'error',
            message: `获取钱包失败。${code}：${msg}`
          })
        })
    },
    clearFilter() {
      this.countdown = 60
      this.verify_locked = true
      const t = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.verify_locked = false
          clearInterval(t)
        }
      }, 1000)
    },
    withdraw() {
      if (!this.amount) {
        this.$message({
          type: 'error',
          message: `请输入提现金额`
        })
        return
      }
      if (Number(this.amount) <= 0) {
        this.$message({
          type: 'error',
          message: `提现金额必须大于0`
        })
        return
      }
      this.confirmDia = true
      this.realAmout = Math.round((this.amount * 10000) / 100)
      //   if (Number(this.amount) < 100) {
      //     this.$message({
      //       type: "error",
      //       message: `提现最少100元`
      //     });
      //     return;
      //   }
    },
    smsConfirm() {
      const params = {
        ticket: this.ticket,
        verify_code: this.verify_code
      }
      this.$store
        .dispatch('SMS_CONFIRM', params)
        .then(data => {
          this.$message({
            type: 'success',
            message: `提现成功`
          })
          this.confirmDia = false
          this.$router.push(this.fromUrl)
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: 'error',
            message: `提现失败。${code}：${msg}`
          })
        })
    },
    sendVerifyCode() {
      this.isLoading = true
      const params = {
        amount: this.realAmout,
        wallet_id: this.$route.params.settle_account
        // jump_url: "http://www.baidu.com"
      }
      this.$store
        .dispatch('WITHDRAW', params)
        .then(data => {
          console.log(data)
          this.ticket = data.ticket
          this.startCountdown()
          this.isLoading = false
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: 'error',
            message: `提现失败。${code}：${msg}`
          })
          this.isLoading = false
        })
    },
    startCountdown() {
      this.verify_locked = true
      this.countdown = 60
      const t = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.countdown = 0
          this.verify_locked = false
          clearInterval(t)
        }
      }, 1000)
    },
    get_uni_config() {
      // 当前的钱包状态
      this.$store
        .dispatch('GET_UNI_CONFIG')
        .then(res => {
          this.manual_withdraw_company_min = (
            res.manual_withdraw_company_min / 100
          ).toFixed(2)
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: 'error',
            message: `获取钱包全局配置失败。${code}：${msg}`
          })
        })
    }
  },
  mounted() {
    this.getWalletInfo()
    this.get_uni_config()
  }
}
</script>
<style lang="less" scoped>
.txt-tip-default {
  color: #275aa0;
}
</style>
